<template>
    <div id="chart" style="height: 35vh; width: 100%"></div>
</template>
  
<script>
import * as echarts from "echarts/core";
import { TooltipComponent, GridComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([GridComponent, TooltipComponent, BarChart, CanvasRenderer]);

export default {
    props: {
        list: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        list: {
            handler() {
                this.setChart();
            },
            deep: true,
        },
    },
    mounted() {
        var chartDom = document.getElementById("chart");
        this.chart = echarts.init(chartDom);
        this.setChart();
    },

    beforeDestroy() {
        this.chart?.dispose();
    },
    methods: {
        setChart() {

            if (this.list.length === 0) return;

            let option = {
                color: ["#FFA700", "#3AA1FF"],
                tooltip: {
                    trigger: "item",
                },
                grid: {
                    top: "10%",
                    left: "20%",
                    right: "3%",
                    bottom: "15%",
                },
                xAxis: {
                    type: "category",
                    splitLine: {
                        show: true,
                    },
                    axisLabel: {
                        color: "#999",
                    },
                    data: this.list.map((item) => item.month),
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        name: "价值",
                        type: "bar",
                        data: this.list.map((item) => item.sum),
                    },
                ],
            };

            option && this.chart.setOption(option);
        }
    }
};
</script>